import React from 'react'
import { useState } from 'react'
import { motion } from "framer-motion"
import { fadeInOut } from '../animations'

const CheckoutInput = ({ placeHolder, icon, inputState, inputStateFunc, type }) => {
    const [isForcus, setIsForcus] = useState(false)
    return (
        <motion.div {...fadeInOut}
        className={`flex items-center justify-center gap-4 bg-white backdrop-blur-md rounded-md w-full px-4 py-2 ${isForcus ? "shadow-md shadow-red-200" : "shadow-none"}`}>
            {icon}
            <input type={type} placeholder={placeHolder} className='w-full h-full bg-transparent text-headingColor text-xl border-none outline-none'
                value={inputState}
                onChange={(e) => inputStateFunc(e.target.value)}
                onFocus={() => setIsForcus(true)}
                onBlur={() => setIsForcus(false)}
            />
        </motion.div>
    )
}

export default CheckoutInput